import moment from "moment";
import React from "react";
import { HiChevronRight } from "react-icons/hi";
import { useNavigate } from "react-router-dom";
import dummy from "src/assets/png/userd-demo-pic.png";
import { useStudent } from "src/contexts/student";
import { NotificationData } from "src/modules/fithub-shared/notifications/index.types";

const NotFeedback: React.FC<{ e: NotificationData }> = ({ e }) => {
  const student = useStudent();

  const nav = useNavigate();

  function loadStudent() {
    try {
      nav(`/student`);
    } finally {
      student.onSetStudent(e.id);
    }
  }

  return (
    <>
      <button
        className="flex flex-1 items-center border-none bg-transparent p-0 hover:opacity-75"
        onClick={loadStudent}
        type="button"
      >
        <img
          className="mr-2 flex h-[30px] w-[30px] rounded-full object-cover"
          src={e.photourl ?? dummy}
          alt={e.name}
          style={{ outline: "none" }}
        />
        <div className="flex flex-col items-center">
          <p className="m-0 h-full text-xs leading-tight text-gray-600 dark:text-gray-300">
            <strong className="pr-1 align-baseline text-black dark:text-white">
              {e.name}
            </strong>
            {e.subtitle.replace("# ", "")}
          </p>
          <p className="mb-0 mt-2 w-full break-words text-left text-[10px] text-gray-500 dark:text-gray-400">
            {moment(e.date).format("LL")}
          </p>
        </div>
      </button>
      <HiChevronRight className="text-gray-400 dark:text-gray-500" />
    </>
  );
};

export default NotFeedback;
